module.exports = __webpack_public_path__ + "static/media/20210109_214719_455_IMG_1810.32ee0597.jpg";